var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3853 32.4739L10.5578 39.2959L3.87841 39.4372C1.88225 35.7348 0.75 31.4989 0.75 26.9976C0.75 22.6448 1.80863 18.54 3.68512 14.9257H3.68656L9.63309 16.0158L12.238 21.9265C11.6928 23.5159 11.3957 25.2221 11.3957 26.9976C11.3959 28.9244 11.7449 30.7706 12.3853 32.4739Z",
    fill: "#FBBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7914 22.0946C53.0929 23.6825 53.2501 25.3224 53.2501 26.9983C53.2501 28.8776 53.0525 30.7108 52.6761 32.479C51.3982 38.4962 48.0592 43.7504 43.4337 47.4686L43.4322 47.4672L35.9422 47.085L34.8822 40.4678C37.9514 38.6679 40.3501 35.8511 41.6136 32.479H27.5768V22.0946H41.8183H52.7914Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4318 47.4693L43.4333 47.4707C38.9347 51.0865 33.2201 53.2499 26.9994 53.2499C17.0026 53.2499 8.31119 47.6626 3.87744 39.4401L12.3843 32.4768C14.6011 38.393 20.3084 42.6045 26.9994 42.6045C29.8754 42.6045 32.5697 41.8271 34.8817 40.4699L43.4318 47.4693Z",
    fill: "#28B446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.756 6.79313L35.252 13.755C32.8592 12.2594 30.0307 11.3954 27.0004 11.3954C20.158 11.3954 14.344 15.8001 12.2382 21.9284L3.68662 14.9276H3.68518C8.05402 6.50469 16.8551 0.75 27.0004 0.75C33.3697 0.75 39.2097 3.01874 43.756 6.79313Z",
    fill: "#F14336"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.87414d616b4aabe690ac21baf0a7d7b2.svg";
export { ForwardRef as ReactComponent };